import DesktopNavigation from './desktop-navigation';
import MobileNavigation from './mobile-navigation';

class LayoutNavigation {
  constructor() {
    this.desktopNavigation = null;
    this.mobileNavigation = null;
    this.container = document.getElementsByClassName('navWrapper')[0];

    if (!this.container) {
      console.log('Navigation MenuWrapperLayout not found');

      return;
    }

    var navContainer = DomHelper.closest(this.container, '.top-navigation-wrapper');
    if (!navContainer) {
      navContainer = document.querySelector('.header-one .nav-one .top-navigation-wrapper');
      navContainer.appendChild(this.container);
    } 

    this.init();
  }

  init() {
    if (!document.getElementsByClassName('layout-nav-overlay')[0]) {
      var mainNavOverlay = document.createElement('div');
      mainNavOverlay.classList.add('layout-nav-overlay')
      document.body.appendChild(mainNavOverlay);
    }
    
    this.mobileNavigation = new MobileNavigation(this.container);
    this.desktopNavigation = new DesktopNavigation(this.container);
    
    this.attachEvents();
    this.stickyHeader();
  }

  attachEvents() {
    var matchMedia = window.matchMedia("(min-width: 992px)");
    if(matchMedia){
      if(matchMedia.addEventListener){
        matchMedia.addEventListener('change', event => {
          this.matchMediaChanged(event);
        });
      }else if(matchMedia.addListener){
        matchMedia.addListener('change', event => {
          this.matchMediaChanged(event);
        });
      }
    }
  }

  matchMediaChanged(event) {
    if (event.matches) {
      this.desktopNavigation.show();
    }
  }

  stickyHeader() {
    var header = document.getElementsByClassName('header-one')[0];

    if (!header) {
      return;
    }

    window.addEventListener('scroll', function () {
        if (window.pageYOffset > 0) {
          DomHelper.addClass('sticky-header', document.body)
        } else {
          DomHelper.removeClass('sticky-header', document.body)
        }
    });
  }
} 
  
export default LayoutNavigation;
  